export const lineOption: any = {
    title: {
        text: "",
        textStyle: {
            fontSize: 18,
            color: "#666",
            fontWeight: "normal"
        },
        left: "20px",
        top: "20px"
    },
    tooltip: {
        trigger: "axis",
        axisPointer: {
            type: "cross",
            label: {
                backgroundColor: "#6a7985"
            }
        }
    },
    xAxis: {
        type: "category",
        boundaryGap: false,
        data: [],
        axisLabel: {
            fontSize: 14
        }
    },
    yAxis: {
        type: "value",
        axisLabel: {
            fontSize: 14
        }
    },
    series: [
        {
            name: "",
            type: "line",
            smooth: true,
            symbolSize: 8,
            data: [],
            lineStyle: {
                color: "rgb(51, 153, 204)"
            },
            areaStyle: {
                color: "rgba(51,153,204,0.15)"
            },
            itemStyle: {
                color: "rgb(51, 153, 204)"
            },
            label: {
                normal: {
                    show: false,
                    position: "top",
                    color: "rgb(51, 153, 204)",
                    fontSize: 14
                }
            }
        }
    ]
};
export const pieOption: any = {
    title: {
        text: "",
        textStyle: {
            fontSize: 18,
            color: "#666",
            fontWeight: "normal"
        },
        left: "20px",
        top: "20px"
    },
    tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    legend: {
        orient: "vertical",
        left: "4%",
        top1: "1%",
        data: []
    },
    color: [
        "#3399cc",
        "#fbbe49",
        "#3b9987",
        "#d48265",
        "#c23531",
        "#91c7ae",
        "#8fb9e4",
        "#d83bd3",
        "#79dd79",
        "#fd8888"
    ],
    series: [
        {
            name: "",
            type: "pie",
            selectedMode: "single",
            radius: [0, "85%"],

            label: {
                position: "inner",
                formatter: "{d}%"
            },
            labelLine: {
                show: false
            },
            data: []
        }
    ]
};
export const mapOption: any = {
    title: {
        text: "",
        textStyle: {
            fontSize: 18,
            color: "#666",
            fontWeight: "normal"
        },
        left: "20px",
        top: "20px"
    },
    tooltip: {
        show: true,
        formatter(params: any) {
            return (
                params.seriesName +
                "：" +
                params.name +
                "<br/>" +
                params.value +
                " , " +
                (params.data["ratio"] * 100).toFixed(2) +
                "%"
            );
        }
    },
    visualMap: [
        {
            min: 0,
            max: 1500,
            left: "left",
            top: "bottom",
            text: ["高", "低"],
            inRange: {
                color: ["#e0ffff", "#006edd"]
            },
            show: true
        }
    ],
    geo: {
        map: "china",
        roam: false,
        zoom: 1.23,
        label: {
            normal: {
                show: true,
                fontSize: "10",
                color: "rgba(0,0,0,0.7)"
            }
        },
        itemStyle: {
            normal: {
                borderColor: "rgba(0, 0, 0, 0.2)"
            },
            emphasis: {
                areaColor: "#F3B329",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
            }
        }
    },
    series: [
        {
            name: "",
            type: "map",
            geoIndex: 0,
            data: []
        }
    ]
};
export const mapBarOption: any = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        show: false
    },
    grid: {
        left: 160,
        top: 20
    },
    xAxis: {
        type: "value",

        splitLine: {
            show: false
        },
        axisLabel: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        }
    },
    yAxis: {
        type: "category",
        inverse: true,
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisPointer: {
            label: {
                show: true,
                margin: 30
            }
        },
        data: [],
        axisLabel: {
            margin: 10,
            fontSize: 14,
            align: "right",
            color: "#333",
        }
    },
    color: [
        "#3399cc",
        "#fbbe49",
        "#3b9987",
        "#d48265",
        "#c23531",
        "#91c7ae",
        "#8fb9e4",
        "#d83bd3",
        "#79dd79",
        "#fd8888"
    ],
    series: [
        {
            z: 2,
            name: "数量",
            type: "bar",
            data: [],
            label: {
                show: true,
                position: "right",
                color: "#333333",
                fontSize: 14,
                offset: [10, 0]
            }
        }
    ]
};
export const barOption: any = {
    title: {
        text: "",
        textStyle: {
            fontSize: 14,
            color: "#666",
            fontWeight: "normal"
        },
        left: "20px",
        top: "20px"
    },
    legend: {
        show: false,
    },
    color: ["#3398DB"],
    tooltip: {
        trigger: "axis",
        // formatter: (params: any) => {
        //     console.log('params');
        //     console.log(params);
        //     return (
        //         params[0].name +
        //         "<br/>" +
        //         params[0].value +
        //         " , " +
        //         (params[0].data.ratio * 100).toFixed(2) +
        //         "%"
        //     );
        // },
        axisPointer: {
            type: "shadow"
        }
    },
    grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
    },
    xAxis: [
        {
            type: "category",
            data: [],
            axisTick: {
                alignWithLabel: true
            }
        }
    ],
    yAxis: [
        {
            type: "value"
        }
    ],
    series: [
        {
            type: "bar",
            barWidth: 70,
            data: []
        }
    ]
};
export const graphOption: any = {
    title: {
        text: '',
        textStyle: {
            fontSize: 18,
            color: "#000",
            fontWeight: "normal",
        },
        top: '20px',
        left: 'center'
    },
    tooltip: {},
    animationDuration: 1500,
    animationEasingUpdate: 'quinticInOut',
    series: [
        {
            name: '',
            type: 'graph',
            layout: 'force',
            force: {
                repulsion: [50, 100]
            },
            data: [],
            links: [],
            categories: [],
            roam: true,
            focusNodeAdjacency: true,
            label: {
                position: 'right',
                formatter: '{b}'
            },
            lineStyle: {
                color: 'source',
                curveness: 0.3
            },
            emphasis: {
                lineStyle: {
                    width: 10
                }
            }
        }
    ]
};
